import { render, staticRenderFns } from "./DownMessageTmpl.vue?vue&type=template&id=43875387&scoped=true&"
import script from "./DownMessageTmpl.vue?vue&type=script&lang=ts&"
export * from "./DownMessageTmpl.vue?vue&type=script&lang=ts&"
import style0 from "./DownMessageTmpl.vue?vue&type=style&index=0&id=43875387&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43875387",
  null
  
)

export default component.exports